export default "__VITE_ASSET__BKdz68PP__"